import { MyInterceptor } from './shared/interceptor/token-interceptor';
import { SharedModule } from './shared/shared.module';
// import { MaterialModule } from './other-modules/matmodules/material.module';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GlobalClassroomComponent } from './features/global-classroom/global-classroom.component';
import { AgmCoreModule } from '@agm/core';
import { AgmOverlays } from 'agm-overlays';
import { MatCarouselModule } from '@ngbmodule/material-carousel';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { MaterialModule } from './other-modules/matmodules/material.module';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';


import { OverlayModule } from '@angular/cdk/overlay';

import { LoaderService } from '../../src/app/shared/services/loader/loader.service'
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MapViewComponent } from './features/map-view/map-view.component';
import { BadgeEarnedComponent } from './features/component/badge-earned/badge-earned.component';
import { TopicCompletedComponent } from './features/component/topic-completed/topic-completed.component';
import { QuestionComponent } from './features/question/question.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CategoryComponent } from './features/teacher/category/category.component';
import { InstructionsComponent } from './features/teacher/instructions/instructions.component';
import { JoinTeamComponent } from './features/teacher/join-team/join-team.component';
import { LeaderboardComponent } from './features/teacher/leaderboard/leaderboard.component';
import { QuizCompletedComponent } from './features/teacher/quiz-completed/quiz-completed.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LobyComponent } from './features/student/loby/loby.component';
import { QuizBeginComponent } from './features/student/quiz-begin/quiz-begin.component';
import { QuizComponent } from './features/student/quiz/quiz.component';
import { QuizFinishedComponent } from './features/student/quiz-finished/quiz-finished.component';
import { GameSettingsComponent } from './features/component/game-settings/game-settings.component';
import { TeamConfigComponent } from './shared/dialogs/team-config/team-config.component';
import { ResultComponent } from './features/teacher/result/result.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}


@NgModule({
  declarations: [
    AppComponent,
    GlobalClassroomComponent,
    MapViewComponent,
    BadgeEarnedComponent,
    TopicCompletedComponent,
    QuestionComponent,
    CategoryComponent,
    InstructionsComponent,
    JoinTeamComponent,
    LeaderboardComponent,
    QuizCompletedComponent,
    LobyComponent,
    QuizBeginComponent,
    QuizComponent,
    QuizFinishedComponent,
    ResultComponent
  ],
  imports: [
    AppRoutingModule,
    CoreModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    HttpClientModule,
    OverlayModule,
    AgmOverlays,
    MatSnackBarModule,
    BrowserAnimationsModule,
    NgxQRCodeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatCarouselModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAFhKH4un9CRCHdhqpZwwb6HTXEtr97n9E'
    }),
    InfiniteScrollModule

  ],
  providers: [
    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MyInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
// AIzaSyAFhKH4un9CRCHdhqpZwwb6HTXEtr97n9E  - prod
// AIzaSyD1zGbgSy6Ec4M6u9iM9pyD9m77qm6SXjk - dev
